export const BestServiceItemsArray = [
  {
    title: "Basement Renovation & Home Remodeling Services",
    subtitle:
      "Professional basement renovation and home remodeling services in Kuala Lumpur, Selangor and across Malaysia. Our licensed home renovation contractors handle insulation, drywall, flooring, ceiling upgrades, custom rooms (bedrooms, home theatres, gyms, playrooms), bathroom installations and lighting improvements — turning unused space into a functional, comfortable living area with quality craftsmanship you can trust.",
    url: "/services-details",
    src: "/img/images/services_img05.png",
    src2: "/img/images/h3_services_img05.png",
    src3: "/img/images/services_item_img05.png",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#e8eaed"><path d="M691.33-615.33H758V-682h-66.67v66.67Zm0 167.33H758v-66.67h-66.67V-448Zm0 166.67H758V-348h-66.67v66.67ZM654-120v-66.67h199.33v-586.66H470V-680l-66.67-47.33V-840H920v720H654Zm-614 0v-393.33l274-196 273.33 196V-120H362.67v-200.67h-97.34V-120H40Zm66.67-66.67h92v-200.66h230.66v200.66h91.34v-292.66L314-627.33 106.67-479.05v292.38ZM654-550ZM429.33-186.67v-200.66H198.67v200.66-200.66h230.66v200.66Z"/></svg>
    ),
  },
  {
    title: "Licensed Electrical Handyman Services",
    subtitle:
      "Trusted licensed handyman electricians for home repair and home maintenance services in Kuala Lumpur and Selangor. From wiring upgrades, panel replacements and lighting installation to electrical troubleshooting and emergency handyman services, our electricians follow strict safety protocols and Malaysian industry standards — so every home improvement and residential repair job is safe, code-compliant and built to last.",
    url: "/services-details",
    src: "/img/images/services_img04.png",
    src2: "/img/images/h3_services_img04.png",
    src3: "/img/images/services_item_img04.png",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#e8eaed"><path d="M338-209.33 430-356h-55.33v-110l-91.34 146.67H338v110ZM226.67-554.67H486v-218.66H226.67v218.66Zm0 368H486V-488H226.67v301.33ZM160-120v-653.33q0-27 19.83-46.84Q199.67-840 226.67-840H486q27 0 46.83 19.83 19.84 19.84 19.84 46.84V-488h60q23.47 0 40.07 16.59 16.59 16.6 16.59 40.08v207.66q0 20.34 16.34 34.67Q702-174.67 723-174.67q21.33 0 39.17-14.33Q780-203.33 780-223.67v-383h-13.33q-14.17 0-23.75-9.58-9.59-9.58-9.59-23.75v-86.67h20V-780h33.34v53.33h40V-780H860v53.33h20V-640q0 14.17-9.58 23.75-9.59 9.58-23.75 9.58h-13.34v382.8q0 42.87-32.83 73.37-32.83 30.5-77.62 30.5-43.77 0-75.33-30.5Q616-181 616-223.67v-207.66q0-1.67-.83-2.5-.84-.84-2.5-.84h-60V-120H160Zm326-66.67H226.67 486Z"/></svg>
    ),
  },
  {
    title: "Plumbing & Home Repair Services",
    subtitle:
      "Reliable plumbing and small home repair services from your local handyman in Kuala Lumpur, Selangor and across Malaysia. From emergency handyman call-outs for leaks, clogged drains and water heater issues to full plumbing renovation and bathroom upgrades, our home repair experts use high-quality materials and proven repair and renovation solutions for long-lasting property improvement.",
    url: "/services-details",
    src: "/img/images/services_img03.png",
    src2: "/img/images/h3_services_img03.png",
    src3: "/img/images/services_item_img03.png",
    icon: (
      <>
        <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.7379 18.7498C18.7379 17.8794 17.2221 15.4468 17.2221 15.4468C17.2221 15.4468 15.6833 17.8794 15.6833 18.7498C15.6833 19.6184 16.3675 20.3229 17.2108 20.3229C18.0537 20.3229 18.7379 19.6184 18.7379 18.7498ZM7.7775 5.12022H4.72292V1.96567H5.55583V0.244141H0V1.96567H0.833333V6.84132C0.833333 8.1089 1.82833 9.13597 3.05542 9.13597H7.7775V9.99673H9.44458V4.26032H7.7775V5.12022ZM19.1658 12.2909V7.41531C19.1658 6.14816 18.1712 5.12066 16.9454 5.12066H12.2225V4.26076H10.5554V9.99761H12.2225V9.1364H15.2775V12.2909H14.4454V14.0125H20V12.2909H19.1658Z"
            fill="currentcolor"
          />
        </svg>
      </>
    ),
  },
  {
    title: "Kitchen Renovation & Remodeling Services",
    subtitle:
      "Complete kitchen renovation and remodeling services in Kuala Lumpur and Selangor — from revamping cabinets and countertops to new flooring, appliance installation and lighting upgrades. As a dedicated renovation kitchen contractor and home renovation expert in Malaysia, we deliver stunning, functional kitchens that combine the best home renovation ideas with affordable, high-quality craftsmanship.",
    url: "/services-details",
    src: "/img/images/services_img01.png",
    src2: "/img/images/h3_services_img01.png",
    src3: "/img/images/services_item_img01.png",
    icon: (
      <>
        <svg viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M26 9.43506H15.5325V7.40254H26V9.43506Z"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.5325 7.40234L18.7337 5.36983H22.7988L26 7.40234"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.7337 5.36987V0.999959H22.7988V5.36987"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.25002 1.00011H13.5V9.43506H1.00003V1.00011H7.25002Z"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.25002 9.43506V1.00011"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.2175 4.04883V6.38623"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.28254 4.04883V6.38623"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.9675 23.9675H15.5325V19.9025H23.9675V23.9675Z"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5 26V17.8699"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.7338 15.8376H17.7175V17.8701"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.9512 15.8376H23.9675V17.8701"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.00003 21.9351H13.5"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.23376 19.9026H8.26628"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.23376 23.9675H8.26628"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5 13.5C12.3776 13.5 11.4675 14.41 11.4675 15.5325"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.43497 13.5C10.5574 13.5 11.4675 14.41 11.4675 15.5325"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5 13.5C12.3776 13.5 11.4675 12.5899 11.4675 11.4675"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.43497 13.5C10.5574 13.5 11.4675 12.5899 11.4675 11.4675"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.75 13.5V11.4675"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7663 12.4836H18.7337"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.36994 15.5325V13.5"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.3862 14.5161H4.35368"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.75815 26.0002C7.75815 26.2808 7.53066 26.5083 7.25002 26.5083C6.96938 26.5083 6.74189 26.2808 6.74189 26.0002C6.74189 25.7196 6.96938 25.492 7.25002 25.492C7.53066 25.492 7.75815 25.7196 7.75815 26.0002Z"
            fill="currentcolor"
          />
          <path
            d="M4.96341 26H1V17.8699H26V26H9.53663"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    title: "Interior & Exterior Painting Services",
    subtitle:
      "Professional interior and exterior painting services for home improvement and house upgrade projects across Kuala Lumpur, Selangor and Malaysia. Our skilled painters prepare surfaces meticulously, apply premium paints and pay close attention to trim, mouldings and edges, plus weather-shielding options to protect exterior walls — giving you a flawless, long-lasting finish.",
    url: "/services-details",
    src: "/img/images/services_img02.png",
    src2: "/img/images/h3_services_img05.png",
    src3: "/img/images/services_item_img05.png",
    icon: (
      <>
        <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.85102 18.5502L3.61443 16.3148L1.69825 18.231C1.08292 18.8464 1.08292 19.8523 1.69825 20.4676C2.3124 21.0818 3.31833 21.0818 3.93366 20.4676L5.85102 18.5502Z"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.54113 18.2402L10.0097 13.7717M8.393 12.1551L3.9245 16.6236"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.7789 9.96709L18.3394 13.5276L17.4187 14.4483C16.755 15.112 15.6696 15.112 15.0059 14.4483L7.71662 7.16013C7.05288 6.49643 7.05288 5.40985 7.71662 4.74611L8.63727 3.8255L12.1978 7.38599"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.03479 4.22305L10.2308 3.02699L19.1391 11.934L17.9418 13.1301"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.3987 13.8408L11.3613 10.8034L8.32391 7.76606C8.75021 9.74334 8.87928 10.7147 8.39302 12.155L9.20078 12.9639L10.0096 13.7717C11.45 13.2854 12.4214 13.4145 14.3987 13.8408Z"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5665 2.59838L16.1178 6.04712"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.1404 5.46392L17.837 7.76733"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.7021 2.02564L14.3987 4.32788"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 8.04275L19.5562 9.48657"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.1232 1.16482L12.6794 2.60864"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.56033 1.00015L4.44411 2.6767L6.12066 3.56052L4.44411 4.4443L3.56033 6.12085L2.67655 4.4443L1 3.56052L2.67655 2.6767L3.56033 1.00015Z"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.8543 16.3298L18.6597 17.8589L20.1888 18.6643L18.6597 19.4698L17.8543 21L17.0477 19.4698L15.5186 18.6643L17.0477 17.8589L17.8543 16.3298Z"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.77368 7.78574L5.47311 9.11431L6.80169 9.81375L5.47311 10.5132L4.77368 11.8406L4.07424 10.5132L2.74567 9.81375L4.07424 9.11431L4.77368 7.78574Z"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.4872 8.67479L13.4889 8.67651"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    title: "Bathroom Renovation & Remodeling",
    subtitle:
      "Modern bathroom renovation and remodeling services near you — replace old fixtures, install new tiles, upgrade to modern bathtubs or showers, improve lighting and add smart storage. A popular home renovation idea for 2026, our bathroom remodeling experts also handle plumbing updates and energy-efficient installations as part of your full house renovation or home improvement project.",
    url: "/services-details",
    src: "/img/images/services_img06.png",
    src2: "/img/images/h3_services_img06.png",
    src3: "/img/images/services_item_img06.png",
    icon: (
      <>
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 9.66669H8.96729L8.05979 0.893939C8.0326 0.63106 7.90209 0.389751 7.69697 0.223097C7.49186 0.056444 7.22894 -0.0219025 6.96606 0.00529323C6.70318 0.032489 6.46187 0.162999 6.29522 0.368113C6.12857 0.573227 6.05022 0.836143 6.07742 1.09902L6.10167 1.33336H0.333333C0.244928 1.33336 0.160143 1.36847 0.0976311 1.43099C0.0351189 1.4935 0 1.57828 0 1.66669V3.00002C0 3.08843 0.0351189 3.17321 0.0976311 3.23572C0.160143 3.29824 0.244928 3.33336 0.333333 3.33336V10.6667C0.333642 10.9318 0.439098 11.186 0.626568 11.3735C0.814037 11.5609 1.06821 11.6664 1.33333 11.6667V15C1.33434 15.8838 1.68585 16.731 2.31075 17.3559C2.93566 17.9808 3.78292 18.3324 4.66667 18.3334H6.81192C6.66176 18.4622 6.54125 18.622 6.45864 18.8018C6.37604 18.9816 6.33329 19.1772 6.33333 19.375V19.6667C6.33333 19.7551 6.36845 19.8399 6.43096 19.9024C6.49348 19.9649 6.57826 20 6.66667 20H16C16.0884 20 16.1732 19.9649 16.2357 19.9024C16.2982 19.8399 16.3333 19.7551 16.3333 19.6667V19.375C16.333 19.056 16.2218 18.747 16.0189 18.5007C15.816 18.2545 15.5339 18.0864 15.2208 18.025L14.7145 16.1346C15.5301 15.9383 16.297 15.5774 16.9681 15.0741C18.0446 14.2674 18.9431 13.0539 19.6386 11.4672C19.645 11.4525 19.6502 11.4374 19.6544 11.4219C19.8086 11.2885 19.9183 11.1112 19.9688 10.9137C20.0194 10.7162 20.0083 10.5079 19.9371 10.3169C19.8658 10.1259 19.7379 9.96122 19.5704 9.845C19.4029 9.72877 19.2039 9.66655 19 9.66669ZM19.3333 10.6667C19.3332 10.7551 19.2981 10.8398 19.2356 10.9023C19.1731 10.9648 19.0884 10.9999 19 11H7.66667V10.3334H19C19.0884 10.3335 19.1731 10.3686 19.2356 10.4311C19.2981 10.4936 19.3332 10.5783 19.3333 10.6667ZM6.33333 3.57273L7 10.0172V11H6.276C6.31399 10.893 6.33338 10.7803 6.33333 10.6667V3.57273ZM6.82371 0.775606C6.86642 0.728239 6.92195 0.694274 6.98358 0.677826C7.0452 0.661378 7.11027 0.663152 7.17091 0.682933C7.23155 0.702715 7.28514 0.739654 7.32521 0.789278C7.36528 0.838902 7.3901 0.89908 7.39667 0.962522L8.29708 9.66669H7.63396L6.74054 1.0304C6.73556 0.98446 6.7404 0.937989 6.75474 0.894063C6.76908 0.850137 6.79259 0.80976 6.82371 0.775606ZM0.666667 2.00002H6V2.66669H0.666667V2.00002ZM1 10.6667V3.33336H5.66667V10.6667C5.66657 10.7551 5.63142 10.8398 5.56893 10.9023C5.50644 10.9648 5.42171 10.9999 5.33333 11H1.33333C1.24496 10.9999 1.16023 10.9648 1.09774 10.9023C1.03525 10.8398 1.0001 10.7551 1 10.6667ZM4 12.8677C4.32796 13.6084 4.89167 14.3017 5.66321 14.8971C6.05307 15.1966 6.47318 15.4545 6.91667 15.6667H5C4.73488 15.6664 4.4807 15.5609 4.29323 15.3735C4.10576 15.186 4.00031 14.9318 4 14.6667V12.8677ZM2 15V11.6667H3.33333V14.6667C3.33383 15.1086 3.50958 15.5322 3.82204 15.8447C4.13449 16.1571 4.55813 16.3329 5 16.3334H7.89896L7.54167 17.6667H4.66667C3.95967 17.6659 3.28185 17.3847 2.78193 16.8848C2.282 16.3848 2.00079 15.707 2 15ZM14.6363 18.4196C14.6553 18.4905 14.6972 18.5531 14.7554 18.5978C14.8136 18.6425 14.8849 18.6667 14.9583 18.6667C15.1389 18.6669 15.3126 18.736 15.444 18.8599C15.5754 18.9838 15.6546 19.1531 15.6655 19.3334H7.00121C7.01206 19.1531 7.09126 18.9838 7.22266 18.8599C7.35405 18.736 7.52775 18.6669 7.70833 18.6667C7.78172 18.6667 7.85305 18.6425 7.91127 18.5978C7.96949 18.5531 8.01134 18.4905 8.03033 18.4196L8.61667 16.231C8.96272 16.2977 9.31424 16.332 9.66667 16.3334H13C13.3539 16.3339 13.7075 16.3095 14.058 16.2604L14.6363 18.4196ZM13 15.6667H9.66667C8.46775 15.6667 7.12333 15.1817 6.07046 14.3693C5.06429 13.5929 4.46417 12.6443 4.35242 11.6667H18.8119C17.4982 14.3568 15.5927 15.6667 13 15.6667Z"
            fill="currentcolor"
          />
          <path
            d="M3.33335 5.99991C3.56441 5.99961 3.78827 5.91942 3.96697 5.77294C4.14568 5.62647 4.26824 5.42271 4.31389 5.1962L4.5176 5.29803C4.59657 5.33675 4.68765 5.3427 4.77098 5.31456C4.85431 5.28643 4.92315 5.2265 4.96249 5.14783C5.00183 5.06916 5.00848 4.97814 4.981 4.89458C4.95352 4.81103 4.89412 4.74173 4.81576 4.70178C4.81576 4.70178 4.10889 4.35086 4.08826 4.3452C3.97857 4.21872 3.83887 4.12181 3.68199 4.06337C3.5251 4.00493 3.35605 3.98683 3.19034 4.01072C3.02464 4.03462 2.86759 4.09974 2.7336 4.20013C2.59962 4.30051 2.49299 4.43293 2.4235 4.58525C2.35401 4.73757 2.32388 4.90489 2.33589 5.07188C2.34789 5.23887 2.40164 5.40017 2.4922 5.54098C2.58277 5.68179 2.70724 5.7976 2.85421 5.87778C3.00118 5.95797 3.16593 5.99996 3.33335 5.99991ZM3.33335 4.66657C3.39927 4.66657 3.46372 4.68612 3.51854 4.72275C3.57335 4.75938 3.61608 4.81144 3.64131 4.87234C3.66654 4.93325 3.67314 5.00028 3.66028 5.06494C3.64741 5.1296 3.61567 5.18899 3.56905 5.23561C3.52243 5.28223 3.46304 5.31397 3.39838 5.32683C3.33372 5.3397 3.2667 5.33309 3.20579 5.30787C3.14488 5.28264 3.09282 5.23991 3.05619 5.1851C3.01956 5.13028 3.00001 5.06583 3.00001 4.99991C3.00011 4.91153 3.03526 4.8268 3.09776 4.76431C3.16025 4.70182 3.24497 4.66667 3.33335 4.66657Z"
            fill="currentcolor"
          />
          <path
            d="M13.0808 3.32358C13.153 3.30555 13.217 3.26393 13.2627 3.20534C13.3085 3.14674 13.3333 3.07454 13.3333 3.00021C13.3333 2.92587 13.3085 2.85367 13.2627 2.79508C13.217 2.73649 13.153 2.69487 13.0808 2.67683C12.7365 2.59114 12.422 2.4133 12.1711 2.16241C11.9202 1.91151 11.7424 1.59703 11.6567 1.25271C11.6387 1.1806 11.5971 1.11658 11.5385 1.07083C11.4799 1.02509 11.4077 1.00024 11.3333 1.00024C11.259 1.00024 11.1868 1.02509 11.1282 1.07083C11.0696 1.11658 11.028 1.1806 11.01 1.25271C10.9243 1.59703 10.7464 1.91151 10.4955 2.16241C10.2446 2.4133 9.93016 2.59114 9.58584 2.67683C9.51373 2.69487 9.44971 2.73649 9.40396 2.79508C9.35822 2.85367 9.33337 2.92587 9.33337 3.00021C9.33337 3.07454 9.35822 3.14674 9.40396 3.20534C9.44971 3.26393 9.51373 3.30555 9.58584 3.32358C9.93016 3.40928 10.2446 3.58712 10.4955 3.83801C10.7464 4.08891 10.9243 4.40339 11.01 4.74771C11.028 4.81982 11.0696 4.88384 11.1282 4.92958C11.1868 4.97533 11.259 5.00017 11.3333 5.00017C11.4077 5.00017 11.4799 4.97533 11.5385 4.92958C11.5971 4.88384 11.6387 4.81982 11.6567 4.74771C11.7424 4.40339 11.9202 4.08891 12.1711 3.83801C12.422 3.58712 12.7365 3.40928 13.0808 3.32358ZM11.3333 3.826C11.1238 3.49206 10.8415 3.20977 10.5075 3.00021C10.8415 2.79065 11.1238 2.50836 11.3333 2.17442C11.5429 2.50836 11.8252 2.79065 12.1591 3.00021C11.8252 3.20977 11.5429 3.49206 11.3333 3.826Z"
            fill="currentcolor"
          />
          <path
            d="M15.1054 7.01704C14.8443 6.92931 14.6071 6.78231 14.4124 6.58756C14.2176 6.3928 14.0706 6.15558 13.9829 5.89449C13.9608 5.82811 13.9184 5.77036 13.8616 5.72944C13.8048 5.68852 13.7366 5.6665 13.6667 5.6665C13.5967 5.6665 13.5285 5.68852 13.4717 5.72944C13.415 5.77036 13.3725 5.82811 13.3504 5.89449C13.2627 6.15558 13.1157 6.3928 12.921 6.58756C12.7262 6.78231 12.489 6.92931 12.2279 7.01704C12.1616 7.03917 12.1039 7.08162 12.063 7.13837C12.0221 7.19512 12.0001 7.26329 12.0001 7.33324C12.0001 7.4032 12.0221 7.47137 12.063 7.52812C12.1039 7.58487 12.1616 7.62732 12.2279 7.64945C12.489 7.73717 12.7262 7.88418 12.921 8.07893C13.1157 8.27369 13.2627 8.51091 13.3504 8.77199C13.3725 8.83838 13.415 8.89613 13.4717 8.93705C13.5285 8.97797 13.5967 8.99999 13.6667 8.99999C13.7366 8.99999 13.8048 8.97797 13.8616 8.93705C13.9184 8.89613 13.9608 8.83838 13.9829 8.77199C14.0706 8.51091 14.2176 8.27369 14.4124 8.07893C14.6071 7.88418 14.8443 7.73717 15.1054 7.64945C15.1718 7.62732 15.2295 7.58487 15.2704 7.52812C15.3113 7.47137 15.3333 7.4032 15.3333 7.33324C15.3333 7.26329 15.3113 7.19512 15.2704 7.13837C15.2295 7.08162 15.1718 7.03917 15.1054 7.01704ZM13.6667 7.93458C13.5025 7.70083 13.2991 7.49736 13.0653 7.33324C13.2991 7.16913 13.5025 6.96566 13.6667 6.73191C13.8308 6.96566 14.0343 7.16913 14.2681 7.33324C14.0343 7.49736 13.8308 7.70083 13.6667 7.93458Z"
            fill="currentcolor"
          />
          <path
            d="M18.3333 4.66667H18V4.33333C18 4.24493 17.9648 4.16014 17.9023 4.09763C17.8398 4.03512 17.755 4 17.6666 4C17.5782 4 17.4934 4.03512 17.4309 4.09763C17.3684 4.16014 17.3333 4.24493 17.3333 4.33333V4.66667H17C16.9116 4.66667 16.8268 4.70179 16.7643 4.7643C16.7017 4.82681 16.6666 4.91159 16.6666 5C16.6666 5.08841 16.7017 5.17319 16.7643 5.2357C16.8268 5.29821 16.9116 5.33333 17 5.33333H17.3333V5.66667C17.3333 5.75507 17.3684 5.83986 17.4309 5.90237C17.4934 5.96488 17.5782 6 17.6666 6C17.755 6 17.8398 5.96488 17.9023 5.90237C17.9648 5.83986 18 5.75507 18 5.66667V5.33333H18.3333C18.4217 5.33333 18.5065 5.29821 18.569 5.2357C18.6315 5.17319 18.6666 5.08841 18.6666 5C18.6666 4.91159 18.6315 4.82681 18.569 4.7643C18.5065 4.70179 18.4217 4.66667 18.3333 4.66667Z"
            fill="currentcolor"
          />
        </svg>
      </>
    ),
  },
];
